var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationEmptyMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#676767;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#F8D7E3;}\n\t.st2{fill:#FFFFFF;stroke:#676767;stroke-width:3.2116;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#676767;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#010101;stroke-width:1.3971;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#818181;stroke-width:1.1928;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#818181;stroke-width:1.1877;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#818181;stroke-width:1.4423;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#818181;stroke-width:1.1538;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#676767;stroke-width:1.1907;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.68,217.27l-1.34,1.45c-1.74,1.88-4.85,1.3-5.79-1.09l-0.29-32.24c-5.03,4.4-15.67,2.1-12.75-15.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.64,218.18c5.29-44.49,5.21-31.68,5.21-31.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.94,183.84c0,0,3.4-0.73,13.42,49.37"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 129.36,
    cy: 145.26,
    r: 48.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9194 -0.3934 0.3934 0.9194 -53.5715 66.7416)",
    className: "st1",
    cx: 136.03,
    cy: 164.06,
    rx: 10.51,
    ry: 8.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 132.74,
    cy: 207.73,
    r: 8.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 132.87,
    y1: 209.84,
    x2: 140.03,
    y2: 223.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.87,
    y1: 209.84,
    x2: 128.12,
    y2: 223.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 132.87,
    cy: 209.77,
    r: 6.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.87,211.44c23.3-0.13,46.61,1.31,69.81,3.73c11.6,1.19,23.17,2.71,34.71,4.46 c11.53,1.79,23.02,3.87,34.46,6.18c11.42,2.41,22.78,5.1,34.07,8.11c11.26,3.1,22.44,6.49,33.47,10.33 c11.01,3.89,21.87,8.21,32.52,12.99c5.25,2.55,10.56,4.97,15.69,7.76c2.57,1.37,5.19,2.66,7.69,4.16l7.55,4.41 c-10.35-5.34-20.87-10.31-31.62-14.72c-10.77-4.37-21.69-8.32-32.71-11.96c-11.07-3.5-22.2-6.81-33.44-9.7 c-11.25-2.89-22.55-5.54-33.93-7.88c-22.75-4.71-45.7-8.43-68.76-11.37c-11.53-1.46-23.09-2.76-34.67-3.85 C26.1,212.94,14.5,212.09,2.87,211.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.57,144.54c3.41,0.61,6.82,1.21,10.23,1.82c-3.95,3.08-7.91,6.16-11.86,9.25 c5.88,1.71,11.77,3.42,17.65,5.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.93,142.49l10.15,2.31l0.15,0.03c0.84,0.19,1.36,1.03,1.17,1.86c-0.09,0.39-0.32,0.71-0.62,0.93 l-12.3,8.68l-0.29-1.53l17.4,5.97l-17.89-4.29c-0.46-0.11-0.74-0.57-0.63-1.03c0.04-0.18,0.14-0.34,0.27-0.45l0.06-0.05 l11.42-9.81l0.7,2.82l-10.32-1.33c-1.14-0.15-1.95-1.2-1.8-2.34s1.2-1.95,2.34-1.8C156.8,142.46,156.87,142.47,156.93,142.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.01,129.53c2.75,1.6,5.51,3.2,8.26,4.79c-1.33,1.47-3.04,2.56-5.03,3.22c2.81,2.32,5.76,4.34,8.72,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.93,127.94l7.92,5.37l0.13,0.09c0.51,0.34,0.64,1.03,0.29,1.54c-0.04,0.06-0.09,0.12-0.14,0.17 c-1.6,1.57-3.6,2.62-5.66,3.14l0.24-1.28c2.54,2.41,5.28,4.63,8.25,6.56c-3.21-1.5-6.28-3.33-9.19-5.41 c-0.32-0.23-0.39-0.67-0.17-0.99c0.08-0.11,0.19-0.19,0.31-0.24l0.1-0.04c1.76-0.72,3.3-1.86,4.4-3.3l0.28,1.79l-8.59-4.21 c-0.91-0.45-1.29-1.55-0.84-2.46c0.45-0.91,1.55-1.29,2.46-0.84C185.78,127.85,185.86,127.89,185.93,127.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210.24,116.02c2.56,2.44,5.7,4.28,9.08,5.32c-2.3,1.12-4.59,2.24-6.89,3.36c2.88,1.41,6.05,2.21,9.26,2.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M212.1,114.08c2.02,2.4,4.68,4.39,7.71,5.68l0.31,0.13c0.81,0.34,1.19,1.28,0.84,2.09 c-0.18,0.42-0.52,0.72-0.91,0.87l-7.21,2.7l0-1.67c2.63,1.63,5.66,2.74,8.85,3.18c-3.22,0.17-6.53-0.33-9.67-1.51 c-0.46-0.17-0.68-0.68-0.51-1.14c0.07-0.19,0.2-0.34,0.36-0.44l0.15-0.09l6.56-4.03l0.24,3.09c-3.73-0.79-7.34-2.48-10.45-4.97 l-0.05-0.04c-1.17-0.93-1.35-2.64-0.42-3.8c0.93-1.17,2.64-1.35,3.8-0.42C211.85,113.82,211.99,113.95,212.1,114.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.72,28.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M116.01,71.43c-0.27,2.79,1.75,5.48,3.63,4.83s2.85-4.39,1.76-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M156.39,37.41c-3.46-0.09-6.23-4.05-5.11-7.33c1.11-3.28,5.72-4.74,8.52-2.7s2.82,6.87,0.04,8.94 c-1.34,0.29-2.68,0.57-4.02,0.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 236.55,
    y1: 170.34,
    x2: 228.22,
    y2: 178.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 228.22,
    y1: 170.34,
    x2: 236.55,
    y2: 178.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 82.83,
    y1: 28.59,
    x2: 76.16,
    y2: 35.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 76.16,
    y1: 28.59,
    x2: 82.83,
    y2: 35.26
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 70.91,
    cy: 91.4,
    r: 2.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.85,148.45c-0.84-3.57,1.98-7.54,5.63-7.92c0.84-0.09,1.47,0.72,1.93,1.43c1.31,2.01,2.16,4.54,1.4,6.82 C48.06,151.05,41.9,149.69,39.85,148.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.58,96.67c-0.84-3.57,1.98-7.54,5.63-7.92c0.84-0.09,1.47,0.72,1.93,1.43c1.31,2.01,2.16,4.54,1.4,6.82 C31.78,99.27,25.63,97.92,23.58,96.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.38,100.33c-1.67-1.31-4.37-0.99-5.69,0.67c-1.32,1.66-1.03,4.36,0.62,5.7s4.36,1.06,5.7-0.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M230.51,54.5c-0.84-3.57,1.98-7.54,5.63-7.92c0.84-0.09,1.47,0.72,1.93,1.43c1.31,2.01,2.16,4.54,1.4,6.82 C238.71,57.11,232.56,55.75,230.51,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.74,105.49c-3.46,0.09-6.23,4.05-5.11,7.33c1.11,3.28,5.72,4.74,8.52,2.7c2.8-2.04,2.82-6.87,0.04-8.94 c-1.34-0.29-2.68-0.57-4.02-0.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.64,216.03c-2.39,0.32-6.16,6.61-8.49,5.98c0.68-4.75,1.35-9.5,2.03-14.25c2.53,2.24,3.58,4.64,6.11,6.87 C226.8,215.08,226.46,216.69,226.64,216.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M297.13,188.73c-2.39,0.32-6.16,6.61-8.49,5.98c0.68-4.75,1.35-9.5,2.03-14.25c2.53,2.24,3.58,4.64,6.11,6.87 C297.29,187.77,296.96,189.38,297.13,188.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationEmptyMessage);
export default __webpack_public_path__ + "static/media/notification_empty_message.4bc4a57f441d6fe2fe07425b8d50f731.svg";
export { ForwardRef as ReactComponent };